import { Modal, Tabs } from '@mantine/core'
import { IconHistory, IconPaperclip } from '@tabler/icons-react'
import type { Estado } from '@serkat/shared'
import { Adjuntos } from './Adjuntos'
import { HistorialEstados } from './HistorialEstados'

interface Props {
  documentoId: string | null
  numero: string
  estado: Estado
  puedeEditar: boolean
  onCerrar: () => void
}

/**
 * Las dos vistas de trazabilidad de un documento, juntas: qué lo respalda y
 * quién lo movió. Se usa igual desde Requerimientos y desde Órdenes.
 */
export function PanelDocumento({ documentoId, numero, estado, puedeEditar, onCerrar }: Props) {
  return (
    <Modal opened={documentoId !== null} onClose={onCerrar} title={numero} size="xl">
      {documentoId && (
        <Tabs defaultValue="adjuntos">
          <Tabs.List mb="md">
            <Tabs.Tab value="adjuntos" leftSection={<IconPaperclip size={15} />}>
              Adjuntos
            </Tabs.Tab>
            <Tabs.Tab value="historial" leftSection={<IconHistory size={15} />}>
              Historial
            </Tabs.Tab>
          </Tabs.List>

          <Tabs.Panel value="adjuntos">
            <Adjuntos documentoId={documentoId} estado={estado} puedeEditar={puedeEditar} />
          </Tabs.Panel>
          <Tabs.Panel value="historial">
            <HistorialEstados documentoId={documentoId} />
          </Tabs.Panel>
        </Tabs>
      )}
    </Modal>
  )
}
